// @flow

import {findCheckedNodeById} from './findCheckedNodeById';

import type {TreeItem} from '@pb/kit-component-tree-v2';
import type {CheckedTree, SubTreeState} from '../typedef';

type GetCheckedStateParams = {|
    checkedIdsTree: CheckedTree,
    checkedIdsList: Array<string>,
    data: TreeItem,
|};

export const getCheckedState = ({checkedIdsList, checkedIdsTree, data}: GetCheckedStateParams): SubTreeState => {
    const {id} = data;
    const node = findCheckedNodeById(checkedIdsTree, id);
    const indeterminate = node ? node.indeterminate : false;
    const checked = checkedIdsList.includes(id) || !!node && !indeterminate;

    return {checked, indeterminate};
};
